import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import LeadSection from "@/components/sections/LeadSection";
import EditorialMarquee from "@/components/Marquee";
import { Reveal } from "@/components/Reveal";
import { Check } from "@phosphor-icons/react";
import { IMAGES } from "@/data/content";

const CAPABILITIES = [
  "Install-only support",
  "Subcontract capability",
  "Crane-coordinated RTU replacements",
  "Duct, gas & electrical coordination",
  "Startup & commissioning",
  "Clear scope & documentation",
  "Reliable jobsite communication",
  "Clean handoff to your client",
];

export default function ContractorPartners() {
  return (
    <>
      <Seo title="Contractor Partners | Genuine Forge — Install & Subcontract Support" description="Install-only and subcontract HVAC support for general contractors and HVAC companies in Chicago — clear scope, documentation, and clean handoffs." />
      <PageHero eyebrow="Contractor Partners" title="Installation support you can schedule around." lede="Genuine Forge provides dependable install-only and subcontract support for GCs and HVAC companies — with clear scope and a clean handoff every time." image={IMAGES.crane} />

      <section className="border-t border-white/10 py-20 md:py-28">
        <div className="mx-auto grid max-w-[1440px] gap-12 px-6 md:px-12 lg:grid-cols-[1fr_1fr]">
          <Reveal>
            <h2 className="max-w-xl font-display text-3xl font-extrabold leading-tight tracking-tight md:text-4xl">A subcontractor that makes you look good.</h2>
            <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-slatex-300">
              We show up prepared, respect the schedule, and document the work. Whether it's a single RTU change-out or ongoing install support, your client sees a clean, professional result.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2">
              {CAPABILITIES.map((c) => (
                <div key={c} className="flex items-start gap-3 bg-ink p-5">
                  <Check size={14} weight="bold" className="mt-0.5 shrink-0 text-brand-ember" />
                  <span className="font-body text-sm text-white">{c}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <EditorialMarquee text="Install-Only Support · Subcontract Capability · Clear Scope · Clean Handoff ·" speed={22} />
      <LeadSection commercial sourcePage="contractor-partners" />
    </>
  );
}
